export default __webpack_public_path__ + "static/media/13.c0851662.jpg";